import React from "react";
import "./Industries.css";

const industries = [
  "Fitnessstudio",
  "Arztpraxis",
  "Kanzlei",
  "Gastronomie",
  "Büro",
  "Kindergarten",
  "Treppenhaus",
  "Hotel",
  "Senioren & Pflegeeinrichtungen",
  "Lagerflächen & Hallen",
  "Markt & Filialbetriebe",
  "Banken & Versicherungen",
];

const Industries = () => {
  return (
    <section className="industries">
      <h2>
        <span className="industries-lead">Wir legen hohen Wert auf</span>{" "}
        <span>maßgeschneiderte Branchenlösungen</span>
      </h2>
      <div className="industry-grid">
        {industries.map((industry, i) => (
          <div className="industry-box" key={i}>
            <div className="overlay">{industry}</div>
            <img src={`/images/industry${i + 1}.jpg`} alt={industry} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Industries;
